function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["list", "start", "accessibility", "onSortStart", "onSortEnd"],
  _excluded2 = ["index", "lockAxis"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/// <reference types="@dnd-kit/utilities" />
import { DndContext } from '@dnd-kit/core';
import { SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import React, { createContext, useContext, useMemo } from 'react';
export function SortableContainer(Component) {
  return function (_ref) {
    var list = _ref.list,
      _ref$start = _ref.start,
      start = _ref$start === void 0 ? 0 : _ref$start,
      accessibility = _ref.accessibility,
      onSortStart = _ref.onSortStart,
      onSortEnd = _ref.onSortEnd,
      props = _objectWithoutProperties(_ref, _excluded);
    var _onSortEnd = function _onSortEnd(event) {
      var active = event.active,
        over = event.over;
      var oldIndex = active.id - 1;
      var newIndex = (over === null || over === void 0 ? void 0 : over.id) - 1;
      onSortEnd === null || onSortEnd === void 0 || onSortEnd({
        oldIndex: oldIndex,
        newIndex: newIndex
      });
    };
    return /*#__PURE__*/React.createElement(DndContext, {
      accessibility: accessibility,
      onDragStart: onSortStart,
      onDragEnd: _onSortEnd
    }, /*#__PURE__*/React.createElement(SortableContext, {
      items: list.map(function (_, index) {
        return index + start + 1;
      }),
      strategy: verticalListSortingStrategy
    }, /*#__PURE__*/React.createElement(Component, props, props.children)));
  };
}
export var SortableItemContext = /*#__PURE__*/createContext({});
export var useSortableItem = function useSortableItem() {
  return useContext(SortableItemContext);
};
export function SortableElement(Component) {
  return function (_ref2) {
    var _ref2$index = _ref2.index,
      index = _ref2$index === void 0 ? 0 : _ref2$index,
      lockAxis = _ref2.lockAxis,
      props = _objectWithoutProperties(_ref2, _excluded2);
    var sortable = useSortable({
      id: index + 1
    });
    var setNodeRef = sortable.setNodeRef,
      transform = sortable.transform,
      transition = sortable.transition,
      isDragging = sortable.isDragging;
    if (transform) {
      switch (lockAxis) {
        case 'x':
          transform.y = 0;
          break;
        case 'y':
          transform.x = 0;
          break;
        default:
          break;
      }
    }
    var style = useMemo(function () {
      var itemStyle = {
        position: 'relative',
        touchAction: 'none',
        zIndex: 1,
        transform: "translate3d(".concat((transform === null || transform === void 0 ? void 0 : transform.x) || 0, "px, ").concat((transform === null || transform === void 0 ? void 0 : transform.y) || 0, "px, 0)"),
        transition: "".concat(transform ? 'all 200ms ease' : '')
      };
      var dragStyle = {
        transition: transition,
        opacity: '0.8',
        transform: "translate3d(".concat((transform === null || transform === void 0 ? void 0 : transform.x) || 0, "px, ").concat((transform === null || transform === void 0 ? void 0 : transform.y) || 0, "px, 0)")
      };
      var computedStyle = isDragging ? _objectSpread(_objectSpread(_objectSpread({}, itemStyle), dragStyle), props.style) : _objectSpread(_objectSpread({}, itemStyle), props.style);
      return computedStyle;
    }, [isDragging, transform, transition, props.style]);
    return /*#__PURE__*/React.createElement(SortableItemContext.Provider, {
      value: sortable
    }, Component(_objectSpread(_objectSpread({}, props), {}, {
      style: style,
      ref: setNodeRef
    })));
  };
}
export function SortableHandle(Component) {
  return function (props) {
    var _useSortableItem = useSortableItem(),
      attributes = _useSortableItem.attributes,
      listeners = _useSortableItem.listeners;
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, attributes, listeners));
  };
}